import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, ComponentFactoryResolver, Injector, ComponentRef } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { PerformerUIState } from './performer.uistate';
import { PerformerRepository } from './performer.repository';
import { PerformerViewModel } from './performer.viewmodel';
import { FormBuilder } from '@angular/forms';
import { BsModalService, BsModalRef } from '@farris/ui-modal';
import { PerformerEditComponent } from './views/performer-edit/performer-edit.component';
import { MessagerService } from '@farris/ui-messager';
import { PerformerOptionsComponent } from './views/performer-options/performer-options.component';
import { DialogComponent } from '@farris/ui-dialog';
import { PerformerEntity } from './entities/performer.entity';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { ExpressionService, InjectedType, ExprEditMode } from '@gsp-svc/expression';
import { ReportingLineDataEntity } from './views/reporting-line/reporting-line-data.entity';
import { PerformerInfo } from './entities/performer-info.entity';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { Observable, of} from 'rxjs';
import { PositionPerformerEntity } from './entities/position-performer.entity';
import { HttpService } from '@ecp-caf/caf-common';
import { ComponentPerformer } from './views/component-performer/component-performer.entity';
import {MatrixDataInfoEntity} from './views/matrix-performer/entitis/matrix-data-info.entity';
import {FDropdownDirective} from "@farris/ui-dropdown";
import { AssignPerformerConfigComponent } from '../assign-performer-config/assign-performer-config.component';
import { ProcessDeUtil } from '../../domain/process-de-util';

@Component({
  selector: 'app-performer',
  templateUrl: './performer.component.html',
  styleUrls: ['./performer.component.scss'],
  providers: [PerformerViewModel, PerformerRepository, PerformerUIState]
})
export class PerformerComponent implements OnInit {

  display = true; // 控制矩阵参与者是否显示

  type: 'defaultPerformer' | 'assignPerformer' = 'defaultPerformer';
  nodeType: 'userActivity' | 'notifyActivity'  = 'userActivity';

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('editFooter') editFooter: TemplateRef<any>;
  @ViewChild(PerformerOptionsComponent) options: PerformerOptionsComponent;
  @ViewChild('participantOptions') optionsDialog: DialogComponent;
  @ViewChild(DatagridComponent) grid: DatagridComponent;
  @ViewChild('dropdownEl') dropDownEl: FDropdownDirective; // 解决选择意见后，下拉菜单无法收折的问题

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(partInfo: PerformerInfo) {
    if (partInfo.performers && partInfo.performers.length > 0) {
      this.uistate.performerInfo.performers = partInfo.performers;
      this.uistate.performersList = this.uistate.performersList.concat(partInfo.performers as any[]);
      this.uistate.performersList.map(performer => performer.description = this.performerDescription(performer as any));
    }
    if (partInfo.variablePerformers && partInfo.variablePerformers.length > 0) {
      this.uistate.performerInfo.variablePerformers = partInfo.variablePerformers;
      this.uistate.performersList = this.uistate.performersList.concat(partInfo.variablePerformers as any[]);
      this.uistate.performersList.map(variablePerformers => variablePerformers.description = this.performerDescription(variablePerformers as any));
    }
    if (partInfo.components && partInfo.components.length > 0) {
      this.uistate.performerInfo.components = partInfo.components;
      partInfo.components.forEach(cmp => {
        this.uistate.performersList.push({
          id: cmp.id,
          type: 'wf.ComponentParticipantExpression',
          performerName: cmp.name,
          description: this.componentDescription(cmp),
          condition: cmp.condition
        });
      });
    }
    if (partInfo.reportingLines && partInfo.reportingLines.length > 0) {
      this.uistate.performerInfo.reportingLines = partInfo.reportingLines;
      partInfo.reportingLines.forEach(r => {
        this.uistate.performersList.push({
          id: r.id,
          type: 'wf.ReportingLineParticipantExpression',
          performerName: r.reportingLineDefName + '-' + r.dimension,
          description: this.reportingLineDescription(r),
          condition: r.condition
        });
      });
    }
    if(partInfo.activityExecutors && partInfo.activityExecutors.length > 0) {
      this.uistate.performerInfo.activityExecutors = partInfo.activityExecutors;
      partInfo.activityExecutors.forEach(handler => {
        this.uistate.performersList.push({
          id: handler.id,
          type: 'wf.ActivityExecutorParticipantExpression',
          performerName: '<' + handler.activityDefName + '>活动办理人',
          description: '<' + handler.activityDefName + '>活动办理人',
          condition: handler.condition
        });
      })
    }
    if (partInfo.matrixParticipants && partInfo.matrixParticipants.length > 0) {
      this.uistate.performerInfo.matrixParticipants = partInfo.matrixParticipants;
      partInfo.matrixParticipants.forEach(r => {
        this.uistate.performersList.push({
          id: r.id,
          type: 'wf.MatrixParticipantExpression',
          performerName: r.matrixDefName + '-' + r.dataFieldAlias,
          description: this.matrixDescription(r),
          condition: r.condition
        });
      });
    }
    if (partInfo.organizationParticipants && partInfo.organizationParticipants.length > 0) {
      this.uistate.performerInfo.organizationParticipants = partInfo.organizationParticipants;
      partInfo.organizationParticipants.forEach(o => {
        this.uistate.performersList.push({
          id: o.id,
          type: 'wf.OrganizationParticipantExpression',
          performerName: o.organizationName,
          description: o.organizationName +'，' +(o.includeChildren ? '包含下级':'不包含下级'),
          condition: o.condition
        });
      })
    }
    if (partInfo.options) {
      this.uistate.performerInfo.options = partInfo.options;
    }
    this.uistate.performerInfo.isAllScope = partInfo.isAllScope;
  }

  @Input() editorParams: any = {};

  editDialog: BsModalRef;
  compRef: ComponentRef<PerformerEditComponent>;
  isClose = true;

  modalConfig = {
    title: '参与者',
    width: 700,
    height: 400,
    showButtons: true
  };
  columns = [
    {
      field: 'type', width: 50, title: '类型',
      formatter: {
        type: 'enum',
        options: { valueField: 'value', textField: 'text', data: this.uistate.typeCollection }
      }
     },
    { field: 'performerName', width: 50, title: '名称' },
    { field: 'description', width: 100, title: '描述', showTips: true },
    {
      field: 'condition', width: 60, title: '启用条件', showTips: true,
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.editConditon(e);
          },
          clear: (e) => {
            if (e.rowData.type === 'wf.ComponentParticipantExpression') {
              const i = this.uistate.performerInfo.components.findIndex(item => item.id === e.rowData.id);
              this.uistate.performerInfo.components[i].condition = '';
            } else if (e.rowData.type === 'wf.ReportingLineParticipantExpression') {
              const i = this.uistate.performerInfo.reportingLines.findIndex(item => item.id === e.rowData.id);
              this.uistate.performerInfo.reportingLines[i].condition = '';
            } else if (e.rowData.type === 'wf.MatrixParticipantExpression') {
              const i = this.uistate.performerInfo.matrixParticipants.findIndex(item => item.id === e.rowData.id);
              this.uistate.performerInfo.matrixParticipants[i].condition = '';
            } else if (e.rowData.type === 'wf.ActivityExecutorParticipantExpression') {
              const i = this.uistate.performerInfo.activityExecutors.findIndex(item => item.id === e.rowData.id);
              this.uistate.performerInfo.activityExecutors[i].condition = '';
            } else if (e.rowData.type === 'wf.OrganizationParticipantExpression'){
              this.uistate.performerInfo.organizationParticipants[0].condition = '';
            }
          }
        }
      }
    }
  ];

  curPerformer: any;
  editState = 'new'; // 编辑状态，用于区分是新增还是编辑  new | edit

  constructor(
    public viewModel: PerformerViewModel,
    public uistate: PerformerUIState,
    private formBuilder: FormBuilder,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private modalService: BsModalService,
    private message: MessagerService,
    public designerUIState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private http: HttpService,
  ) {
    this.GetOrganizationType();
  }

  ngOnInit() {
    this.type = this.editorParams.type;
    this.nodeType = this.editorParams.nodeType;
    this.getMatrixConfig().subscribe(re => {
      if (re && re.currentValue === 'false') {
        this.display = false;
      }
    });
  }
  switchChange(data: boolean) {
    if (data) {
      this.uistate.clearPerformer();
    }
  }
  // add() {
  //   this.editState = 'new';
  //   const compFactory = this.resolver.resolveComponentFactory(PerformerEditComponent);
  //   this.compRef = compFactory.create(this.injector);
  //   this.compRef.instance.display = this.display;

  //   const modalConfig = {
  //     title: '参与者选择',
  //     width: 700,
  //     height: 400,
  //     buttons: this.editFooter,
  //     showButtons: true
  //   };
  //   this.editDialog = this.modalService.show(this.compRef, modalConfig);
  // }
  addPerformer(performerType: string){
    this.editState = 'new';
    const compFactory = this.resolver.resolveComponentFactory(PerformerEditComponent);
    this.compRef = compFactory.create(this.injector);
    this.compRef.instance.display = this.display;
    this.compRef.instance.performerType = performerType;

    const modalConfig = {
      title: '参与者选择',
      width: 700,
      height: 400,
      buttons: this.editFooter,
      showButtons: true
    };
    this.editDialog = this.modalService.show(this.compRef, modalConfig);
    this.dropDownEl.close();
  }
  edit() {
    this.editState = 'edit';
    if (this.uistate.curPerformer) {
      const modalConfig = {
        title: '参与者选择',
        width: 700,
        height: 400,
        buttons: this.editFooter,
        showButtons: true
      };
      const compFactory = this.resolver.resolveComponentFactory(PerformerEditComponent);
      this.compRef = compFactory.create(this.injector);
      this.compRef.instance.performerType = this.uistate.curPerformer.type;
      switch (this.uistate.curPerformer.type) {
        case 'wf.PositionParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.PositionParticipantExpression',
            value: this.uistate.performerInfo.performers.find(p => p.id === this.uistate.curPerformer.id)
          };
          break;
        case 'wf.UserParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.UserParticipantExpression',
            value: this.uistate.performerInfo.performers.find(p => p.id === this.uistate.curPerformer.id)
          };
          break;
        case 'wf.VariableParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.VariableParticipantExpression',
            value: this.uistate.performerInfo.variablePerformers.find(p => p.id === this.uistate.curPerformer.id)
          };
          break;
        case 'wf.ReportingLineParticipantExpression':
          const reportingLine = this.uistate.performerInfo.reportingLines.find(r => {
            return r.id === this.uistate.curPerformer.id;
          });
          this.compRef.instance.performer = {
            type: 'wf.ReportingLineParticipantExpression',
            value: reportingLine
          };
          const url = '/api/runtime/wf/v1.0/reportingLineDefinitions/' + reportingLine.reportingLineDefId;
          this.http.get(url).subscribe((res: any) => {
            if (!res) {
              this.message.error('该条汇报关系数据的定义已删除，该条数据将删除')
              this.remove();
            } else {
              this.editDialog = this.modalService.show(this.compRef, modalConfig);
            }
          });
          break;
        case 'wf.MatrixParticipantExpression':
          const matrix = this.uistate.performerInfo.matrixParticipants.find(r => {
            return r.id === this.uistate.curPerformer.id;
          });
          this.compRef.instance.performer = {
            type: 'wf.MatrixParticipantExpression',
            value: matrix
          };
          const urlMatrix = '/api/runtime/wf/v1.0/matrixDefinition/' + matrix.matrixDefId;
          this.http.get(urlMatrix).subscribe((res: any) => {
            if (!res) {
              this.message.error('该条矩阵数据的定义已删除，该条数据将删除')
              this.remove();
            } else {
              this.editDialog = this.modalService.show(this.compRef, modalConfig);
            }
          });
          break;
        case 'wf.ComponentParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.ComponentParticipantExpression',
            value: this.uistate.performerInfo.components.find(c => {
              return c.id === this.uistate.curPerformer.id;
            })
          };
          break;
        case 'wf.ActivityExecutorParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.ActivityExecutorParticipantExpression',
            value: this.uistate.performerInfo.activityExecutors.find( c => {
              return c.id === this.uistate.curPerformer.id;
            })
          };
          break;
        case 'wf.OrganizationParticipantExpression':
          this.compRef.instance.performer = {
            type: 'wf.OrganizationParticipantExpression',
            value: this.uistate.performerInfo.organizationParticipants[0]
          };
          break;
      }
      if(this.uistate.curPerformer.type !== 'wf.ReportingLineParticipantExpression' &&
        this.uistate.curPerformer.type !== 'wf.MatrixParticipantExpression'){ // 汇报关系和矩阵单独处理
        this.editDialog = this.modalService.show(this.compRef, modalConfig);
      }
    }
  }
  remove() {
    if (this.grid.selectedRow) {
      this.grid.endCellEdit();
      if (this.grid.selectedRow.data.type === 'wf.ComponentParticipantExpression') {
        const i = this.uistate.performerInfo.components.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.components.splice(i, 1);
      } else if (this.grid.selectedRow.data.type === 'wf.ReportingLineParticipantExpression') {
        const i = this.uistate.performerInfo.reportingLines.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.reportingLines.splice(i, 1);
      } else if (this.grid.selectedRow.data.type === 'wf.MatrixParticipantExpression') {
        const i = this.uistate.performerInfo.matrixParticipants.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.matrixParticipants.splice(i, 1);
      } else if (this.grid.selectedRow.data.type === 'wf.ActivityExecutorParticipantExpression') {
        const i = this.uistate.performerInfo.activityExecutors.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.activityExecutors.splice(i, 1);
      } else if (this.grid.selectedRow.data.type === 'wf.OrganizationParticipantExpression') {
        const i = this.uistate.performerInfo.organizationParticipants = new Array();
      } else if (this.grid.selectedRow.data.type === 'wf.VariableParticipantExpression') {
        const i = this.uistate.performerInfo.variablePerformers.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.variablePerformers.splice(i, 1);
      } else {
        const i = this.uistate.performerInfo.performers.findIndex(item => item.id === this.grid.selectedRow.data.id);
        this.uistate.performerInfo.performers.splice(i, 1);
      }
      const index = this.uistate.performersList.findIndex(p => p.id === this.grid.selectedRow.data.id);
      this.uistate.performersList.splice(index, 1);

      this.grid.loadData(this.uistate.performersList);
    } else {
      this.message.info('请先选中一条参与者信息！');
    }
  }
  clear() {
    this.uistate.performerInfo.performers = [];
    this.uistate.performerInfo.variablePerformers = [];
    this.uistate.performerInfo.components = [];
    this.uistate.performerInfo.reportingLines = [];
    this.uistate.performerInfo.matrixParticipants = [];
    this.uistate.performerInfo.activityExecutors = [];
    this.uistate.performerInfo.organizationParticipants = new Array();
    this.uistate.performersList = [];
    this.grid.loadData(this.uistate.performersList);
  }

  clickOK() {
    this.grid.endCellEdit();
    const object = {
      value: this.uistate.performerInfo, parameters: null
    };
    this.submitModal.emit(object);
  }
  clickCancel() {
    this.closeModal.emit();
  }
  editOK() {
    this.isClose = true;
    if (this.compRef) {
      const re = this.compRef.instance.getPerformers();
      if (re.userPerformers && re.userPerformers.length > 0) {
        re.userPerformers.forEach(p => {
          const i = this.uistate.performerInfo.performers.findIndex(a => (a.id === p.id || a.performerId === p.performerId));
          if (i > -1) {
            const id = this.uistate.performerInfo.performers[i].id;
            this.uistate.performerInfo.performers[i] = p;
            const index = this.uistate.performersList.findIndex(a => a.id === id);
            this.uistate.performersList[index] = p;
          } else {
            if (this.editState === 'edit') {
              this.remove();
            }
            this.uistate.performerInfo.performers.push(p);
            this.uistate.performersList = this.uistate.performersList.concat([p]);
          }
        });
        this.uistate.performersList
          .filter(p => p.type === this.uistate.typeCollection[0].value || p.type === this.uistate.typeCollection[1].value )
          .map(performer => performer.description =
            this.performerDescription(performer as any));
      }
      if (re.positions && re.positions.length > 0) {
        for (const position of re.positions) {
          if (position && position !== null && position.id) {
            const p = position;
            if (!p.performerId) {
              this.message.info('尚未选择岗位！');
              this.isClose = false;
            } else {
              if ((!p.orgType || p.orgType == null) && (p.isRequired && p.positionType === '1')) {
                this.message.info('尚未选择组织类型！');
                this.isClose = false;
              } else if ((!p.orgId || p.orgId == null) && (p.isRequired && p.positionType === '1')) {
                this.message.info('尚未填写组织！');
                this.isClose = false;
              } else {
                // (1)id一致，为编辑岗位；（2）performid一致，新增的用户，岗位已存在
                const i = this.uistate.performerInfo.performers.findIndex(a => (a.id === p.id || (a.performerId === p.performerId && a.orgId === p.orgId)));
                if (i > -1) {
                  const id = this.uistate.performerInfo.performers[i].id;
                  this.uistate.performerInfo.performers[i] = p;
                  const index = this.uistate.performersList.findIndex(a => a.id === id);
                  this.uistate.performersList[index] = p;
                } else {
                  this.uistate.performerInfo.performers.push(p);
                  this.uistate.performersList = this.uistate.performersList.concat([p]);
                }
                this.uistate.performersList
                  .filter(p => p.type === this.uistate.typeCollection[0].value || p.type === this.uistate.typeCollection[1].value)
                  .map(performer => performer.description =
                    this.performerDescription(performer as any));
              }
            }
          }
        }
      }

      if (re.component && re.component.metadataId && re.component.methodCode) {
        const i = this.uistate.performerInfo.components.findIndex(a => a.id === re.component.id);
        if (i > -1) {
          this.uistate.performerInfo.components[i] = re.component;
          const index = this.uistate.performersList.findIndex(a => a.id === re.component.id);
          this.uistate.performersList[index] = {
            id: re.component.id,
            type: 'wf.ComponentParticipantExpression',
            performerName: re.component.name,
            description: this.componentDescription(re.component),
            condition: re.component.condition
          };
        } else {
          this.uistate.performerInfo.components.push(re.component);
          this.uistate.performersList.push({
            id: re.component.id,
            type: 'wf.ComponentParticipantExpression',
            performerName: re.component.name,
            description: this.componentDescription(re.component),
            condition: ''
          });
        }
      }
      if (re.reportingLine && re.reportingLine.reportingLineDefId && re.reportingLine.dimension) {
        if(re.reportingLine.reportingReferObject === 'dept' && !re.reportingLine.refOrgId){
          this.isClose = false;
          this.message.info('“部门”汇报关系类型下，参照人所在部门不能为空');
        } else if (re.reportingLine.reportingReferObject !== 'dept' && !re.reportingLine.refUserId && !re.reportingLine.refEmployeeId) { // 用户及其他人员汇报对象类型，参照用户和参照员工不能全部为空
          this.isClose = false;
          this.message.info('“用户”汇报关系类型下，参照人不能为空');
        } else {
          this.isClose = true;
          this.addReportingLineData(re);
        }
      }
      if (re.matrix && re.matrix.matrixDefId) {
        if(!re.matrix.conditionField1 && !re.matrix.conditionField2 && !re.matrix.conditionField3){
          this.isClose = false;
          this.message.info('条件字段至少要存在一个');
        } else if(!re.matrix.dataFieldAlias){
          this.isClose = false;
          this.message.info('数据字段不能为空');
        } else {
          this.isClose = true;
          this.addMatrixData(re);
        }
      }
      if (re.activityExecutorPerformers && re.activityExecutorPerformers.length > 0) {
        re.activityExecutorPerformers.forEach(p => {
          const i = this.uistate.performerInfo.activityExecutors.findIndex(a => (a.id === p.id || a.activityDefId === p.activityDefId));
          if (i < 0) {
            if (this.editState === 'edit') {
              this.remove(); // 在编辑状态下配置了活动办理人参与者，先将选中的删除
            }
            this.uistate.performerInfo.activityExecutors.push(p);
            this.uistate.performersList = this.uistate.performersList.concat([p]);
          }
        });
        this.uistate.performersList
          .filter(p => p.type === this.uistate.typeCollection[5].value )
          .map(performer => performer.description =
            this.performerDescription(performer as any));
      }
      if (re.organizationParticipant) {
        console.log(re.organizationParticipant);
        this.uistate.performerInfo.organizationParticipants = [re.organizationParticipant];
        this.uistate.performersList = this.uistate.performersList.filter(p => p.type !== 'wf.OrganizationParticipantExpression');
        this.uistate.performersList = this.uistate.performersList.concat({
          id: re.organizationParticipant.id || ProcessDeUtil.GenerateElementId(),
          type: 'wf.OrganizationParticipantExpression',
          performerName: re.organizationParticipant.organizationName,
          description: re.organizationParticipant.organizationName +'，且' +(re.organizationParticipant.includeChildren ? '包含下级':'不包含下级'),
          condition: re.organizationParticipant.condition
        });
      }
      this.grid.loadData(this.uistate.performersList);
    }
    if (this.editDialog && this.isClose) {
      this.editDialog.close();
    }
  }
  private addReportingLineData(re: any){
    const i = this.uistate.performerInfo.reportingLines.findIndex(a => a.id === re.reportingLine.id);
    if (i > -1) {
      this.uistate.performerInfo.reportingLines[i] = re.reportingLine;
      const index = this.uistate.performersList.findIndex(a => a.id === re.reportingLine.id);
      this.uistate.performersList[index] = {
        id: re.reportingLine.id,
        type: 'wf.ReportingLineParticipantExpression',
        performerName: re.reportingLine.reportingLineDefName + '-' + re.reportingLine.dimension,
        description: this.reportingLineDescription(re.reportingLine),
        condition: re.reportingLine.condition
      };
    } else {
      for(const reportingLineData of this.uistate.performerInfo.reportingLines){
        if(reportingLineData.reportingLineDefId === re.reportingLine.definitionId &&
          reportingLineData.dimension === re.reportingLine.dimension &&
          reportingLineData.refUserId === re.reportingLine.referUserId &&
          reportingLineData.refEmployeeId === re.reportingLine.refEmployeeId &&
          reportingLineData.refOrgId === re.reportingLine.referDeptId
        ){
          this.message.error('该汇报关系已经进行过配置');
          return;
        }
      }
      this.uistate.performerInfo.reportingLines.push(re.reportingLine);
      this.uistate.performersList.push({
        id: re.reportingLine.id,
        type: 'wf.ReportingLineParticipantExpression',
        performerName: re.reportingLine.reportingLineDefName + '-' + re.reportingLine.dimension,
        description: this.reportingLineDescription(re.reportingLine),
        condition: re.reportingLine.condition
      });
    }
  }
  private addMatrixData(re: any){
    const i = this.uistate.performerInfo.matrixParticipants.findIndex(a => a.id === re.matrix.id);
    if (i > -1) {
      this.uistate.performerInfo.matrixParticipants[i] = re.matrix;
      const index = this.uistate.performersList.findIndex(a => a.id === re.matrix.id);
      this.uistate.performersList[index] = {
        id: re.matrix.id,
        type: 'wf.MatrixParticipantExpression',
        performerName: re.matrix.matrixDefName + '-' + re.matrix.dataFieldAlias,
        description: this.matrixDescription(re.matrix),
        condition: re.matrix.condition
      };
    } else {
      for(const matrixData of this.uistate.performerInfo.matrixParticipants){
        if(matrixData.matrixDefId === re.matrix.matrixDefId &&
          matrixData.conditionField1 === re.matrix.conditionField1 &&
          matrixData.conditionField2 === re.matrix.conditionField2 &&
          matrixData.conditionField3 === re.matrix.conditionField3 &&
          matrixData.dataFieldAlias === re.matrix.dataFieldAlias
        ){
          this.message.error('该矩阵已经进行过配置');
          return;
        }
      }
      this.uistate.performerInfo.matrixParticipants.push(re.matrix);
      this.uistate.performersList.push({
        id: re.matrix.id,
        type: 'wf.MatrixParticipantExpression',
        performerName: re.matrix.matrixDefName + '-' + re.matrix.dataFieldAlias,
        description: this.matrixDescription(re.matrix),
        condition: re.matrix.condition
      });
    }
  }
  editCancel() {
    if (this.editDialog) {
      this.editDialog.close();
    }
  }
  participantOptionsSet() {
    this.uistate.performerInfo.options = this.options.getPerformerOptions();
    this.optionsDialog.close();
  }

  private performerDescription(performer: PerformerEntity) {
    if (performer.type === 'wf.UserParticipantExpression' || performer.type === 'wf.VariableParticipantExpression') {
      if (performer.tag === 'expression') {
        return performer.performerId;
      } else {
        if (performer.orgName) {
          return `组织：${performer.orgName}`;
        } else {
          return '';
        }
      }
    } else if (performer.type === 'wf.PositionParticipantExpression') {
      if (this.designerUIState.scene === 'inSuite') {
        return null;
      }
      if ((performer as PositionPerformerEntity).positionType === '1') {
        if (performer.orgId) {
          return `岗位类型：通用岗位，组织：${performer.orgId}`;
        } else {
          return `岗位类型：通用岗位`;
        }
      } else if ((performer as PositionPerformerEntity).positionType === '0') {
        return '岗位类型：组织岗位';
      }
    } else if(performer.type === 'wf.ActivityExecutorParticipantExpression') {
      return performer.performerName;
    }
  }
  private componentDescription(component: ComponentPerformer) {
    let des = `构件：${component.name},参数：{`;
    if (component.actualParameters && component.actualParameters.length > 0) {
      component.actualParameters.forEach(p => {
        des += `${p.code}：${p.value}，`;
      });
      des = des.substring(0, des.length - 1);
    }
    des += '}';
    return des;
  }
  private reportingLineDescription(reportingLine: ReportingLineDataEntity) {
    let description = '';
    if(reportingLine.refUserId){
      description += `参照人：${reportingLine.refUserId}`;
    }
    if(reportingLine.refEmployeeId){
      description += `参照人：${reportingLine.refEmployeeId}`;
    }
    if(reportingLine.refOrgId){
      if(reportingLine.refUserId){
        description += `，`;
      }
      if(reportingLine.refEmployeeId){
        description += `，`;
      }
      description += `参照组织：${reportingLine.refOrgId}`;
    }
    return description;
  }
  private matrixDescription(matrix: MatrixDataInfoEntity) {
    let description = '';
    if(matrix.conditionField1){
      description += `条件1：${matrix.conditionFieldText1}，`;
    }
    if(matrix.conditionField2){
      description += `条件2：${matrix.conditionFieldText2}，`;
    }
    if(matrix.conditionField3){
      description += `条件3：${matrix.conditionFieldText3}，`;
    }
    if(matrix.dataFieldAlias){
      description += `数据：${matrix.dataFieldAlias}，`;
    }
    return description.slice(0, description.length - 1);
  }

  editConditon(e: any) {
    // this.expr.clearContext();
    if (this.designerUIState.schemas.length > 0) {
      for (const schema of this.designerUIState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerUIState.schemas[0].entityTypes && this.designerUIState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerUIState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerUIState.addContext(context);
    if (this.designerUIState.subActivityContext.length > 0) {
      for (const variable of this.designerUIState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (this.designerUIState.activityComponentContext.length > 0) {
      for (const variable of this.designerUIState.activityComponentContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.addExpressionText(e.instance.value);
    this.expr.setEditPattern(ExprEditMode.Conditional); // 默认打开简易表达式编辑器
    this.expr.buildExpression().then((cond: string) => {
      if (this.grid.selectedRow.data.type === 'wf.ComponentParticipantExpression') {
        this.uistate.performerInfo.components.find(c => c.id === this.grid.selectedRow.data.id).condition = cond;
      } else if (this.grid.selectedRow.data.type === 'wf.ReportingLineParticipantExpression') {
        this.uistate.performerInfo.reportingLines.find(c => c.id === this.grid.selectedRow.data.id).condition = cond;
      } else if (this.grid.selectedRow.data.type === 'wf.MatrixParticipantExpression'){
        this.uistate.performerInfo.matrixParticipants.find(c => c.id === this.grid.selectedRow.data.id).condition = cond;
      } else if (this.grid.selectedRow.data.type === 'wf.ActivityExecutorParticipantExpression'){
        this.uistate.performerInfo.activityExecutors.find(c => c.id === this.grid.selectedRow.data.id).condition = cond;
      } else {
        this.uistate.performerInfo.performers.find(p => p.id === this.grid.selectedRow.data.id).condition = cond;
      }
      e.formControl.setValue(cond);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  afterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    return of(true);
  }

  selectChanged(data: any) {
    this.uistate.curPerformer = data.data;
  }

  private GetOrganizationType() {
    const url = '/api/runtime/sys/v1.0/authfields/globalauthfields';
    this.http.get(url)
      .subscribe((data: any) => this.designerUIState.orgTypeCollection = data.map(d => ({ value: d.id, text: d.name })));
  }

  private getMatrixConfig(): Observable<any> {
    const url = `/api/runtime/wf/v1.0/generalConfig/Is_EnableMatrix`;
    return this.http.get(url);
  }

}
export class PerformerConverter implements TypeConverter {
  constructor() { }

  convertTo(data: any): string {
    if ((data.performers && data.performers.length > 0)
      || (data.variablePerformers && data.variablePerformers.length > 0)
      || (data.components && data.components.length > 0)
      || (data.reportingLines && data.reportingLines.length > 0)
      || (data.matrixParticipants && data.matrixParticipants.length > 0)
      || (data.activityExecutors && data.activityExecutors.length > 0)
      || (data.organizationParticipants && data.organizationParticipants.length > 0)
      || data.isAllScope
    ) {
      return '（已设置）';
    } else {
      return '（未设置）';
    }
  }
}
